import { TenantEntity } from '../TenantEntity'

export class BillingGroup extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'BillingGroup'
  }
  get billingId() {
    return this._data.billingId
  }
  set billingId(billingId) {
    this._data.billingId = billingId || 0
  }
  get billingNo() {
    return this._data.billingNo
  }
  set billingNo(billingNo) {
    this._data.billingNo = billingNo || ''
  }
  get counterPartyBillingNo() {
    return this._data.counterPartyBillingNo
  }
  set counterPartyBillingNo(counterPartyBillingNo) {
    this._data.counterPartyBillingNo = counterPartyBillingNo || ''
  }
  get billingType() {
    return this._data.billingType
  }
  set billingType(billingType) {
    this._data.billingType = billingType || ''
  }
  get ar() {
    return this._data.ar
  }
  set ar(ar) {
    this._data.ar = ar || false
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get accountId() {
    return this._data.accountId
  }
  set accountId(accountId) {
    this._data.accountId = accountId || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency || ''
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate || 0.0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0.0
  }
  get currencyAmount() {
    return this._data.currencyAmount
  }
  set currencyAmount(currencyAmount) {
    this._data.currencyAmount = currencyAmount || ''
  }
  get bankAccountId() {
    return this._data.bankAccountId
  }
  set bankAccountId(bankAccountId) {
    this._data.bankAccountId = bankAccountId || 0
  }
  get invoiceDemand() {
    return this._data.invoiceDemand
  }
  set invoiceDemand(invoiceDemand) {
    this._data.invoiceDemand = invoiceDemand || ''
  }
  get title() {
    return this._data.title
  }
  set title(title) {
    this._data.title = title || ''
  }
  get titleBranchId() {
    return this._data.titleBranchId
  }
  set titleBranchId(titleBranchId) {
    this._data.titleBranchId = titleBranchId || 0
  }
  get billingAddress() {
    return this._data.billingAddress
  }
  set billingAddress(billingAddress) {
    this._data.billingAddress = billingAddress || ''
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark || ''
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales || 0
  }
  get buyerTaxAccount() {
    return this._data.buyerTaxAccount
  }
  set buyerTaxAccount(buyerTaxAccount) {
    this._data.buyerTaxAccount = buyerTaxAccount || ''
  }
  get buyerBank() {
    return this._data.buyerBank
  }
  set buyerBank(buyerBank) {
    this._data.buyerBank = buyerBank || ''
  }
  get buyerBankAccount() {
    return this._data.buyerBankAccount
  }
  set buyerBankAccount(buyerBankAccount) {
    this._data.buyerBankAccount = buyerBankAccount || ''
  }
  get buyerAddress() {
    return this._data.buyerAddress
  }
  set buyerAddress(buyerAddress) {
    this._data.buyerAddress = buyerAddress || ''
  }
  get buyerTelephone() {
    return this._data.buyerTelephone
  }
  set buyerTelephone(buyerTelephone) {
    this._data.buyerTelephone = buyerTelephone || ''
  }
  // 发票类型
  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType || ''
  }
  // 发票种类
  get invoiceMakeType() {
    return this._data.invoiceMakeType
  }
  set invoiceMakeType(invoiceMakeType) {
    this._data.invoiceMakeType = invoiceMakeType || ''
  }
  // 虚拟字段(非数据库实体字段)------------------
  // 用于查询账单
  get billingKeys() {
    return this._data.billingKeys
  }
  set billingKeys(billingKeys) {
    this._data.billingKeys = billingKeys || []
  }
  // 保存时，记录发生变动的账集合
  get diffBillings() {
    return this._data.diffBillings
  }
  set diffBillings(diffBillings) {
    this._data.diffBillings = diffBillings || []
  }
  // 业务状态
  get jobState() {
    return this._data.jobState
  }
  set jobState(jobState) {
    this._data.jobState = jobState || 0
  }
  // 创建对账单时选择的收付方式 0：应付；1：应收；-1：全部（应收和应付账单一起创建对账单） 默认选择应收
  get makeBillingGroupPaymentReceiveMethod() {
    return this._data.makeBillingGroupPaymentReceiveMethod
  }
  set makeBillingGroupPaymentReceiveMethod(makeBillingGroupPaymentReceiveMethod) {
    this._data.makeBillingGroupPaymentReceiveMethod = makeBillingGroupPaymentReceiveMethod || 1
  }

  // 对方对账单号
  get otherPartyBilling() {
    return this._data.otherPartyBilling
  }
  set otherPartyBilling(otherPartyBilling) {
    this._data.otherPartyBilling = otherPartyBilling || ''
  }
  // 发票备注
  get invoiceRemark() {
    return this._data.invoiceRemark
  }
  set invoiceRemark(invoiceRemark) {
    this._data.invoiceRemark = invoiceRemark || ''
  }
}
